// src/storage.ts

type Storekey = '__mode__' | '_app_token' | '_login_type' | '_app_profile_' | `_app_user_`  | 
    '_app_onboarding' | 'id' | '_currencyCode_';

const storage = {
  get<T>(key: Storekey): T | null {
    const value = sessionStorage.getItem(key);

    if (!value) return null;

    return JSON.parse(value) as T;
  },

  set<T>(key: Storekey, value: T) {
    sessionStorage.setItem(
      key,
      JSON.stringify(value)
    );
  },

  remove(key: Storekey) {
    sessionStorage.removeItem(key);
  },

  clear() {
    sessionStorage.clear();
  },
};

export default storage;